import { ICustomMappings } from '@principle-theorem/practice-migrations/interfaces';
import { BaseCustomMappingsHandler } from '../mappings/base-custom-mappings-handler';
import { OasisStafferMappingHandler } from './destination/mappings/staff';
import { OasisPracticeMappingHandler } from './destination/mappings/practices';
import { OasisFeeScheduleMappingHandler } from './destination/mappings/fee-schedules';
import { OasisPatientNoteCategoryToNoteMappingHandler } from './destination/mappings/patient-note-categories-to-notes';
import { OasisItemCodeMappingHandler } from './destination/mappings/item-codes';
import { OasisItemCodeToTreatmentMappingHandler } from './destination/mappings/item-code-to-treatment';
import { OasisItemCodeToConditionMappingHandler } from './destination/mappings/item-code-to-condition';
import { OasisAppointmentBookToPractitionerMappingHandler } from './destination/mappings/appointment-book-to-practitioner';
import { OasisPatientNoteTypeToNoteMappingHandler } from './destination/mappings/patient-note-types-to-notes';
import { OasisAppointmentBookToStatusMappingHandler } from './destination/mappings/appointment-book-to-status';
import { OasisStaffToUserMappingHandler } from './destination/mappings/staff-to-user';
import { AppointmentCategoryToTreatmentCategoryMappingHandler } from './destination/mappings/appointment-category-to-treatment-category';
import { OasisAppointmentStepSizeMappingHandler } from './destination/mappings/appointment-step-size';

export const OASIS_MAPPINGS: ICustomMappings = {
  metadata: {
    label: 'OASiS Custom Mappings',
    description: '',
  },
};

export class OasisCustomMappingsHandler extends BaseCustomMappingsHandler {
  migrationType = 'OASiS';
  migrationVersion = 'v1';
  customMapping = OASIS_MAPPINGS;

  mappingHandlers = [
    new OasisFeeScheduleMappingHandler(),
    new OasisItemCodeMappingHandler(),
    new OasisItemCodeToConditionMappingHandler(),
    new OasisItemCodeToTreatmentMappingHandler(),
    new OasisPatientNoteCategoryToNoteMappingHandler(),
    new OasisPatientNoteTypeToNoteMappingHandler(),
    new OasisPracticeMappingHandler(),
    new OasisStafferMappingHandler(),
    new OasisAppointmentBookToPractitionerMappingHandler(),
    new OasisAppointmentBookToStatusMappingHandler(),
    new OasisStaffToUserMappingHandler(),
    new AppointmentCategoryToTreatmentCategoryMappingHandler(),
    new OasisAppointmentStepSizeMappingHandler(),
  ];
}
